<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户停车卡</el-breadcrumb-item>
      <el-breadcrumb-item>对账统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col :span="4">
          <el-date-picker v-model="queryInfo.queryStartDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="统计日期起"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker v-model="queryInfo.queryEndDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="统计日期止"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getConsumeList1">查&nbsp;&nbsp;询</el-button>
        </el-col>
      </el-row>

      <el-card>
        <el-tag type="success">停车卡消费订单数：<span>{{statInfo.sumOrders}}</span> 笔</el-tag>
        <el-tag type="danger">停车卡消费总金额：<span>{{statInfo.sumFee}}</span> 元</el-tag>
      </el-card>

      <el-table border strip :data="dataList">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="手机号码" prop="phoneNo"></el-table-column>
        <el-table-column label="客户姓名" prop="userName"></el-table-column>
        <el-table-column label="消费金额" prop="fee"></el-table-column>
        <el-table-column label="消费日期">
          <template slot-scope="scope">{{scope.row.logTime | dateFormat}}</template>
        </el-table-column>
        <el-table-column label="剩余金额" prop="remainMoney"></el-table-column>
        <el-table-column label="停车卡金额" prop="amount"></el-table-column>
        <el-table-column label="有效期起">
          <template slot-scope="scope">{{scope.row.beginTime | dateFormatYMD}}</template>
        </el-table-column>
        <el-table-column label="有效期止">
          <template slot-scope="scope">{{scope.row.endTime | dateFormatYMD}}</template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getMonthStart, getMonthEnd, dateFormat } from '@/utils/utils'
export default {
  created () {
    this.initPage()// 页面初始化
  },
  data () {
    return {
      token: '', // 页面暂存token
      merchantId: '', // 商户ID
      dataList: [], // 查询列表数据
      total: 0, // 查询数据总条数
      queryInfo: { // 查询条件
        queryStartDate: getMonthStart(),
        queryEndDate: getMonthEnd(),
        pagenum: 1,
        pagesize: 10
      },
      statInfo: { // 统计信息
        sumFee: 0,
        sumOrders: 0
      }
    }
  },
  methods: {
    // 页面初始化
    initPage () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.token = token
      // 获取merchantId
      const merchantId = window.sessionStorage.getItem('merchantId')
      if (undefined === merchantId || merchantId === '') { // 判断merchantId是否存在
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.merchantId = merchantId
      // 初始化查询
      this.getConsumeList1()
    },

    // 点击查询按钮查询
    getConsumeList1 () {
      this.queryInfo.pagenum = 1
      this.getConsumeList()
    },

    // 查询商户消费详情列表以及统计信息（异步）
    getConsumeList () {
      // 处理日期查询条件
      let startDateStr = null
      let endDateStr = null
      if (this.queryInfo.queryStartDate !== null) {
        startDateStr = dateFormat(this.queryInfo.queryStartDate) + ' 00:00:00'
      }
      if (this.queryInfo.queryEndDate !== null) {
        endDateStr = dateFormat(this.queryInfo.queryEndDate) + ' 23:59:59'
      }

      // 查询列表
      this.$http.get('queryMerchantCardConsume', {
        headers: { token: this.token },
        params: {
          // 查询参数
          pagenum: this.queryInfo.pagenum,
          pagesize: this.queryInfo.pagesize,
          queryStartDate: startDateStr,
          queryEndDate: endDateStr,
          merchantId: this.merchantId
        }
      }).then(result => {
        const res = result.data
        this.dataList = res.rows
        this.total = res.total
      })

      // 查询统计信息
      this.$http.get('queryMerchantCardStat', {
        headers: { token: this.token },
        params: {
          // 查询参数
          queryStartDate: startDateStr,
          queryEndDate: endDateStr,
          merchantId: this.merchantId
        }
      }).then(result => {
        const res = result.data
        if (res.code === '0') {
          this.statInfo.sumFee = res.data.sumFee
          this.statInfo.sumOrders = res.data.sumOrders
        }
      })
    },

    // 监听pagesize改变
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getCardsList()
    },

    // 当前页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getCardsList()
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.el-col {
  margin: 7px 7px 7px 7px;
}
.el-tag {
  margin: 5px 5px 5px 5px;
}
</style>
